// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sFTAa{display:-webkit-box;display:flex;left:0;position:fixed;right:0;top:0;-webkit-box-align:center;align-items:center;-webkit-box-pack:center;background:#c0fff3;justify-content:center;padding:20px;text-align:center;z-index:1000}.ZLNTt{color:#4a4a4a;font-size:14px;line-height:1.57;margin:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `sFTAa`,
	"para": `ZLNTt`
};
module.exports = ___CSS_LOADER_EXPORT___;
